export const CardV2LayoutClasses =
  "md:shadow-componentCard md:rounded-v2-layout-card md:border md:border-card-border bg-v2-card";
export const CardV2LayoutNoShadowClasses =
  "md:rounded-v2-layout-card md:border md:border-card-border bg-v2-card";
export const MobileTopMargin = "mt-2 [.v2-embedded-map_&]:mt-0";
export const MobileBottomCalcPercent = "h-[calc(100%-103px)]";
export const MobileBottomCalcVh = "h-[calc(100vh-52px)]";
/**
 * Outer padding for the shell that wraps a `SurfaceCard` page surface. Change
 * it here to adjust the gap around every section card at once.
 */
export const SurfaceCardShellPadding = "py-[10px] pr-[10px] pl-[3px]";
/**
 * `md:`-scoped variant of {@link SurfaceCardShellPadding}, for shells that are
 * full-bleed on mobile and only gain the card gap from `md` up (e.g. the
 * settings/admin section layout and the map sidebar column). Keep its values in
 * sync with `SurfaceCardShellPadding`.
 */
export const SurfaceCardShellPaddingMd =
  "md:py-[10px] md:pr-[10px] md:pl-[3px]";
/**
 * Margin equivalent of {@link SurfaceCardShellPaddingMd}, for absolutely
 * positioned surfaces (e.g. the map's overlay sidebar cards). Padding on the
 * containing element does not offset abs-positioned children, so those cards
 * reproduce the shell gap with a margin instead. Keep the values in sync.
 */
export const SurfaceCardShellMarginMd =
  "md:my-[10px] md:mr-[10px] md:ml-[3px]";
/**
 * Complementary to the SurfaceCard shell padding above: when true, the app's
 * main sidebar keeps its right-border width on every section (so nothing
 * shifts) but renders it transparent everywhere except the dashboard, which
 * keeps the solid border. Set to false to restore a solid right border on all
 * sections. Consumed by `AppMainLayout` together with
 * {@link SidebarBorderVisible} / {@link SidebarBorderTransparent}.
 */
export const TRANSPARENT_SIDEBAR_BORDER_EXCEPT_DASHBOARD = true;
/** Solid right-border color for the app sidebar (dashboard / flag disabled). */
export const SidebarBorderVisible = "md:border-r-neutral-100";
/** Transparent right border that preserves the sidebar border width. */
export const SidebarBorderTransparent = "md:border-r-transparent";
/**
 * The shared surface look for a page card: white background, 14px radius,
 * hairline border and a soft shadow. Backs the `SurfaceCard` component; use the
 * component where you can, and this constant only when the surface must be
 * applied conditionally to an existing element.
 */
export const SurfaceCardClasses =
  "overflow-hidden rounded-[14px] border border-[#e6eaee] bg-white shadow-[0px_1px_2px_0px_rgba(16,36,73,0.05)]";
export const MobileMapTopMargin = "mt-[140px]";
export const MobileMapBottomMargin = "mb-[53px]";
